/* eslint-disable react/destructuring-assignment */
import { Grid, ThemeProvider } from "@mui/material";
import { adminTheme } from "./adminTheme";
import { useEffect, useState } from "react";
import Topbar from "../components/Topbar";
import CollapsableSidebar from "./sidebar/CollapsableSidebar";
import { UsendLoadingMark } from "../components/loader/UsendMarks";
import { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { storeSelector } from "../redux/slices/storeSlice";
import { authSelector, setSidebarExpandStatus } from "../redux/slices/authSlice";
import { useLocation } from "react-router-dom";
import AdminNavigation from "./sidebar/AdminNavigation";
import AdminTopbar from "./AdminTopbar";
import layoutStyles from "./adminLayout.module.css";
import useIsMobile from "../hooks/useIsMobile";
import CustomerLayout from "./CustomerLayout";
import { isClientPreview } from "../utils/clientPreview";

// Admin: dark sidebar with the page as a rounded card beside it. The collapsed
// state lives in redux (persisted), because every admin page mounts its own layout.
// On phones the sidebar is a drawer, opened from the top bar.
function AdminLayout({ children, background }) {
  const dispatch = useDispatch();
  const { sideBarExpand } = useSelector(authSelector);
  const mobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const expanded = mobile || sideBarExpand !== false;

  useEffect(() => {
    if (!drawerOpen) return undefined;
    const onKey = (e) => e.key === "Escape" && setDrawerOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [drawerOpen]);

  return (
    <ThemeProvider theme={adminTheme}>
      <div className={layoutStyles.shell}>
        <div className={`${layoutStyles.navWrap} ${drawerOpen ? layoutStyles.navOpen : ""}`}>
          <AdminNavigation
            expanded={expanded}
            onToggle={() =>
              mobile ? setDrawerOpen(false) : dispatch(setSidebarExpandStatus(!expanded))
            }
          />
        </div>
        <div
          className={`${layoutStyles.scrim} ${drawerOpen ? layoutStyles.scrimVisible : ""}`}
          onClick={() => setDrawerOpen(false)}
          aria-hidden="true"
        />
        <div
          className={`hide_scrollbar ${layoutStyles.card}`}
          style={{
            background: background || "#fff",
            "--admin-page-bg": background || "#fff",
          }}
        >
          <AdminTopbar onMenu={mobile ? () => setDrawerOpen(true) : undefined} />
          <main className={layoutStyles.main}>
            <Suspense
              fallback={
                <div style={{ height: "60vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <UsendLoadingMark size={32} />
                </div>
              }
            >
              {children}
            </Suspense>
          </main>
        </div>
      </div>
    </ThemeProvider>
  );
}

// `background`: admin only, the page card colour (pages restyled to the new look use #f1f1f1).
function AppLayout({ children, background }) {
  const [sidebarExpand, setSidebarExpand] = useState(true);
  const { announcement } = useSelector(storeSelector);
  const { loggedUser } = useSelector(authSelector);

  const liveAnnouncement =
    announcement?.announcement?.length > 0 && announcement?.announcement[0];

  const location = useLocation().pathname;

  if (loggedUser?.user?.role === "admin") {
    return <AdminLayout background={background}>{children}</AdminLayout>;
  }

  if (isClientPreview()) {
    return <CustomerLayout announcement={liveAnnouncement}>{children}</CustomerLayout>;
  }

  return (
    <>
      {liveAnnouncement && loggedUser?.user?.role !== "admin" && (
        <div
          style={{
            padding: "5px",
            background: "#8D40FF",
            zIndex: 1000,
            position: "fixed",
            width: "100%",
            top: 0,
            textAlign: "center",
            color: "#fff",
          }}
        >
          {liveAnnouncement?.announcement}
        </div>
      )}

      <Grid container style={{ height: "100%", overflowY: "hidden" }}>
        <Grid
          item
          xs={sidebarExpand ? 2 : 0.5}
          style={{ transition: "all 0.5s ease-in-out" }}
        >
          <CollapsableSidebar
            sidebarUtil={{ sidebarExpand, setSidebarExpand }}
          />
        </Grid>
        <Suspense
          fallback={
            <div
              style={{
                height: location === "/customer/dashboard" ? "auto" : "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <UsendLoadingMark size={32} />
            </div>
          }
        >
          <Grid
            item
            xs={sidebarExpand ? 10 : 11.5}
            style={{
              height: location === "/customer/dashboard" ? "auto" : "100vh",
              overflowY: "scroll",
              transition: "all 0.5s ease-in-out",
              // paddingBottom: "150px",
              // display: "flex",
              // justifyContent: "center",
              // margin: "0 auto",
              background: loggedUser?.user?.role !== "admin" ? "#f4f4f4" : "",
            }}
            className="hide_scrollbar"
          >
              <Topbar />
            <div
              style={{
                background:
                loggedUser?.user?.role !== "admin" ? "linear-gradient(280deg, #341073 0%, #210D44 101.66%)":"",
                height: location === "/customer/dashboard" ? "auto" : location === "/customer/orders" ? "443px":"423px",
                display: "flex",
                justifyContent: "center",
              }}
            >
            
              <main
                style={{
                  transition: "all 0.5s ease-in-out",
                  width: "100%",
                  padding: "0px 30px",
                  maxWidth: "1600px",
                  marginTop:
                    liveAnnouncement && loggedUser?.user?.role !== "admin"
                      ? "118px"
                      : "83px",
                }}
              >
                <div>{children}</div>
              </main>
            </div>
          </Grid>
        </Suspense>
      </Grid>
    </>
  );
}

export default AppLayout;
